import { Spinner } from "theme-ui";
import React, { useEffect } from "react";

export const AppLoader = () => {
  useEffect(() => {
    const start = Date.now();
    console.log(`[AppLoader] Loading started at: ${new Date(start).toISOString()}`);
    return () => {
      const end = Date.now();
      const duration = end - start;
      console.log(`[AppLoader] Loading ended at: ${new Date(end).toISOString()} (duration: ${duration} ms)`);
    };
  }, []);

  return (
    <div className="flex flex-row items-center justify-center h-screen z-50 bg-main">
      <Spinner sx={{ m: 2, color: "white" }} size="32px" />
      <div className="text-style-plain">Loading...</div>
    </div>
  );
};
